module.exports = __webpack_public_path__ + "img/图片1.3803f286.png";